module.exports = __webpack_public_path__ + "static/media/hotel-8.400cddcd.jpg";